export default __webpack_public_path__ + "static/media/course8.253d7d9f.png";